app.SiteList = app.AbstractCollection.extend({
  model: app.Site,

  url() {
    return '/api/v2/sites';
  },
});
